import { Icon } from '@tcc/crate';
import { categoryTypeColor, categoryTypePinIcon } from '../../utils/scoutingUtils';
import { EnhancedActivity } from '../../types';

type EnhancedPinProps = {
  activity: EnhancedActivity;
}

export const EnhancedPin = ({ activity }: EnhancedPinProps) => {
  const color = activity.categoryType ? categoryTypeColor(activity.categoryType) : activity.color;

  return (
    <div data-test-id={`enhanced-pin-${activity.id}`} style={{ color }}>
      <Icon glyph={categoryTypePinIcon(activity.categoryType)} />
    </div>
  )
};
